let config = {
  API_BASE_URL: '',
  APPLICATION_LANGUAGE: 'en-US',
  ADMIN_AUTH_TIME_RECALL: 3600000, // In milli seconds, default 1 hour
  VISION_LAYOUTS_API: '',
  AUTHORIZE_USER_TOKEN_API: '',
  ECLIENT_USE_PATHS: '',
  EX_CLIENT_VALUE: 'CareerAchievement',
  ECLIENT_TOKEN_LINK: '',
  GIVE_WIDGET_JS: '',
  GIVE_WIDGET_CSS: '',
  ROUTE_ESCAPE_PATHS: '',
  BIND_ACTIVITIES_MENU_MATCH: '',
  VISON_LAYOUTS_TRANSLATIONS_API: '',
  COOKIE_ATTACH_DOMAIN: '.appreciatehub.com',
  COOKIE_ATTACH_CC_DOMAIN: 'localhost',
  CONTACT_US_LINK: '',
  PRIVACY_POLICY_LINK: '',
  ECLIENT_LINK_LOGOUT: '',
  LEGACY_ROOT_URL: '',
  TOKEN_ECLIENT_PARAM: '_eclientlink_access_token',
  PRODUCT_UPDATES: 'https://www.octanner.com/product-releases.html',
  CC_PRODUCT_UPDATES: 'https://www.octanner.com/cc-product-releases.html',
  PRODUCT_ROADMAP: '/ui/adminhome/updates/octannerroadmap',
  ADMIN_AUTH_ESCAPE_PATHS: '',
  DISPLAY_HEADER: 'budgetdashboard',
  DEFAULT_LOGO_URL: '/ui/greatwork/',
  COMMON_UI_JACKET_URL: 'http://localhost:5000',
  NORMAL_URL_MATCH: 'localhost',
  CC_VISION_LAYOUTS_API: '',
  CC_AUTHORIZE_USER_TOKEN_API: '',
  CORE_AUTH_URL: '',
  COOKIES_PATH: '/',
  PRODUCT_ROADMAP_ENABLED: 'false',
  GATEWAY_API_URL:
    'https://graphqlgateway-core-prd.alamoapp.octanner.io/graphql',
  SAME_SITE_ATTRIBUTE: 'Lax',
  GROUP_DEPOSITS_BASE_PATH: 'groupdeposits',
  TOKEN_EXPIRATION_MINUTES: 15,
  APP_NAME: 'commonuijacket-perf-dev',
  APP_VERSION: 'V1',
  CC_DOMAIN: 'http://localhost:9000'
};

let numberOfTimesConfigSet = 0;

export const setConfig = (cfg) => {
  if (numberOfTimesConfigSet === 0) {
    config = Object.assign({}, config, cfg);
    numberOfTimesConfigSet += 1;
  }
};

const getConfig = (name) => config[name];

export default getConfig;
